import {css} from 'styled-components';

export const truncateStringAfterLines = (lines: number) => css`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${lines};
  overflow: hidden;
  text-overflow: ellipsis;
`;
